export default theme => ({
  compact: {
    color: theme.palette.disabled.main,
    marginRight: 10,
    display: "inline-block",
    verticalAlign: "middle",
  },
  icon__disabled: {
    color: theme.palette.disabled.light,
  },
});
